/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiV0WorkDayCreateWorkDayPost } from '../fn/working-day/api-v-0-work-day-create-work-day-post';
import { ApiV0WorkDayCreateWorkDayPost$Params } from '../fn/working-day/api-v-0-work-day-create-work-day-post';
import { apiV0WorkDayDeleteByIdDelete } from '../fn/working-day/api-v-0-work-day-delete-by-id-delete';
import { ApiV0WorkDayDeleteByIdDelete$Params } from '../fn/working-day/api-v-0-work-day-delete-by-id-delete';
import { apiV0WorkDayGetAllWorkingDaysByCompanyGet$Json } from '../fn/working-day/api-v-0-work-day-get-all-working-days-by-company-get-json';
import { ApiV0WorkDayGetAllWorkingDaysByCompanyGet$Json$Params } from '../fn/working-day/api-v-0-work-day-get-all-working-days-by-company-get-json';
import { apiV0WorkDayGetAllWorkingDaysByCompanyGet$Plain } from '../fn/working-day/api-v-0-work-day-get-all-working-days-by-company-get-plain';
import { ApiV0WorkDayGetAllWorkingDaysByCompanyGet$Plain$Params } from '../fn/working-day/api-v-0-work-day-get-all-working-days-by-company-get-plain';
import { apiV0WorkDayUpdateWorkDayPost } from '../fn/working-day/api-v-0-work-day-update-work-day-post';
import { ApiV0WorkDayUpdateWorkDayPost$Params } from '../fn/working-day/api-v-0-work-day-update-work-day-post';
import { WorkDay } from '../models/work-day';

@Injectable({ providedIn: 'root' })
export class WorkingDayService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiV0WorkDayGetAllWorkingDaysByCompanyGet()` */
  static readonly ApiV0WorkDayGetAllWorkingDaysByCompanyGetPath = '/api/v0/workDay/getAllWorkingDaysByCompany';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0WorkDayGetAllWorkingDaysByCompanyGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0WorkDayGetAllWorkingDaysByCompanyGet$Plain$Response(params?: ApiV0WorkDayGetAllWorkingDaysByCompanyGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<WorkDay>>> {
    const obs = apiV0WorkDayGetAllWorkingDaysByCompanyGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0WorkDayGetAllWorkingDaysByCompanyGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0WorkDayGetAllWorkingDaysByCompanyGet$Plain(params?: ApiV0WorkDayGetAllWorkingDaysByCompanyGet$Plain$Params, context?: HttpContext): Observable<Array<WorkDay>> {
    const resp = this.apiV0WorkDayGetAllWorkingDaysByCompanyGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<WorkDay>>): Array<WorkDay> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0WorkDayGetAllWorkingDaysByCompanyGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0WorkDayGetAllWorkingDaysByCompanyGet$Json$Response(params?: ApiV0WorkDayGetAllWorkingDaysByCompanyGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<WorkDay>>> {
    const obs = apiV0WorkDayGetAllWorkingDaysByCompanyGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0WorkDayGetAllWorkingDaysByCompanyGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0WorkDayGetAllWorkingDaysByCompanyGet$Json(params?: ApiV0WorkDayGetAllWorkingDaysByCompanyGet$Json$Params, context?: HttpContext): Observable<Array<WorkDay>> {
    const resp = this.apiV0WorkDayGetAllWorkingDaysByCompanyGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<WorkDay>>): Array<WorkDay> => r.body)
    );
  }

  /** Path part for operation `apiV0WorkDayCreateWorkDayPost()` */
  static readonly ApiV0WorkDayCreateWorkDayPostPath = '/api/v0/workDay/createWorkDay';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0WorkDayCreateWorkDayPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0WorkDayCreateWorkDayPost$Response(params?: ApiV0WorkDayCreateWorkDayPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiV0WorkDayCreateWorkDayPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0WorkDayCreateWorkDayPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0WorkDayCreateWorkDayPost(params?: ApiV0WorkDayCreateWorkDayPost$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiV0WorkDayCreateWorkDayPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiV0WorkDayUpdateWorkDayPost()` */
  static readonly ApiV0WorkDayUpdateWorkDayPostPath = '/api/v0/workDay/updateWorkDay';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0WorkDayUpdateWorkDayPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0WorkDayUpdateWorkDayPost$Response(params?: ApiV0WorkDayUpdateWorkDayPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiV0WorkDayUpdateWorkDayPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0WorkDayUpdateWorkDayPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0WorkDayUpdateWorkDayPost(params?: ApiV0WorkDayUpdateWorkDayPost$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiV0WorkDayUpdateWorkDayPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiV0WorkDayDeleteByIdDelete()` */
  static readonly ApiV0WorkDayDeleteByIdDeletePath = '/api/v0/workDay/deleteById';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0WorkDayDeleteByIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0WorkDayDeleteByIdDelete$Response(params?: ApiV0WorkDayDeleteByIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiV0WorkDayDeleteByIdDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0WorkDayDeleteByIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0WorkDayDeleteByIdDelete(params?: ApiV0WorkDayDeleteByIdDelete$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiV0WorkDayDeleteByIdDelete$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
